export default __webpack_public_path__ + "static/media/640_dummy2016-diy01-de.4ed1d2c5.png";